// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"Z7-z"};